import { Dialog } from '../../dialog';
import { DialogType } from '../../dialog/types';
import { useDialog } from './dialog-context';

type DialogsComponentType = Partial<DialogType> & {
    name: string;
};

const DialogsComponent: React.FC<DialogsComponentType> = ({
    name,
    children,
    ...props
}) => {
    const { isDialogOpen, closeDialog } = useDialog();

    return (
        <Dialog
            {...props}
            open={isDialogOpen(name)}
            onClose={() => closeDialog(name)}>
            {children}
        </Dialog>
    );
};

export default DialogsComponent;
